import JoditEditor, { IJoditEditorProps } from "jodit-react";
import { useRef, useEffect, useState, useMemo } from "react";
import { debounce } from "lodash";

const HtmlCode = ({
  content,
  setContent,
  label = "",
  placeholder = "start tyiping text",
}) => {
  const editor = useRef(null);

  const handleBlur = (newContent) => {
    setContent(newContent);
  };

  const configed = {
    readonly: true,
    height: "50%",
    uploader: {
      insertImageAsBase64URI: true,
    },
    placeholder: "Start typing here...",
    toolbar: false,
  };

  // Ensure content is always a string
  const safeContent = typeof content === "string" ? content : "";

  return (
    <>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
        {/* <p className="inline-block text-base font-medium">Old Text</p> */}
        <div className="xl:col-span-12">
          <label
            htmlFor="phoneNumberIn"
            className="inline-block mb-2 text-base font-medium"
          >
            {label}
          </label>
          <JoditEditor
            ref={editor}
            value={safeContent}
            config={configed}
            onBlur={handleBlur}
            // onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default HtmlCode;
